<script>
export default {
  name: "ModalAuth",
  data(){
    return {
      openWin: false
    }
  },
  methods:{
    scrollToForm(){
      this.$root.$refs.modals.closeModal()
      let scrollCorrect = '39'
      if (window.innerWidth <= 700){scrollCorrect = 109}
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#lead-form").offset().top - scrollCorrect
      }, 0);
    }
  }
}
</script>

<template>
    <div class="modal-auth">
      <div class="title left">
        Профиль
      </div>
      <div class="desc left">
        Вы переходите в личный кабинет (ЛК) на платформе <strong>Telegram</strong>. Вход доступен только для <strong>зарегистрированных пользователей</strong>. Если вы хотите стать нашим клиентом, сообщите нам об этом.
      </div>
      <div class="buttons left flex flex-x-center">
        <a @click.prevent="scrollToForm()" class="btn-teg left">Связаться</a>
        <a href="https://t.me/rented77_bot" target="_blank" class="btn-teg left" >Продолжить</a>
      </div>
    </div>
</template>

<style scoped>

</style>